export default __webpack_public_path__ + "static/media/scramble.5c1f3eb0.png";